export default "__VITE_ASSET__BYZkLQd___"